import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

export interface CustomPhoneFieldProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  value: string;
  onChange: (e: any) => void;
}

const formatPhone = (input: string) => {
  const digits = input.replace(/\D/g, '');
  if (digits.length <= 10) {
    // Landline: (99) 9999-9999
    return digits.replace(/(\d{0,2})(\d{0,4})(\d{0,4})/, (match, p1, p2, p3) => {
      let result = '';
      if (p1) result += `(${p1}`;
      if (p1 && p1.length === 2) result += ') ';
      if (p2) result += p2;
      if (p2 && p2.length === 4) result += '-';
      if (p3) result += p3;
      return result;
    });
  }
  // Mobile: (99) 99999-9999
  return digits.replace(/(\d{0,2})(\d{0,5})(\d{0,4})/, (match, p1, p2, p3) => {
    let result = '';
    if (p1) result += `(${p1}`;
    if (p1 && p1.length === 2) result += ') ';
    if (p2) result += p2;
    if (p2 && p2.length === 5) result += '-';
    if (p3) result += p3;
    return result;
  });
};

const CustomPhoneField: React.FC<CustomPhoneFieldProps> = ({ value, onChange, ...props }) => {
  return (
    <TextField
      {...props}
      value={value}
      onChange={(e) => {
        const formatted = formatPhone(e.target.value);
        onChange({ ...e, target: { ...e.target, value: formatted } });
      }}
      inputProps={{ maxLength: 15, ...(props.inputProps || {}) }}
      variant="standard"
    />
  );
};

export default CustomPhoneField;
